import React, { useState, useEffect } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { pastelPalette } from '../constants/color.constants';

import { DraggableHeader } from './DraggableTab';
import '../css/dashboard.styles.css';
import { getRandomItem, iconList } from './RandomTabIcon';

const DraggableTabs = ({
  tabsValue,
  allTabs,
  onTabClick,
  showAdd,
  handleAddIcon,
  handleTabState,
  setLoading,
}) => {
  const [tabList, setTabList] = useState([]);

  useEffect(() => {
    const enrichedTabs = allTabs.map(tab => ({
      ...tab,
      randomIcon: getRandomItem(iconList),
      randomColor: getRandomItem(pastelPalette),
    }));
    setTabList(enrichedTabs);
  }, [allTabs]);

  const moveTab = (dragIndex, hoverIndex) => {
    const updated = [...tabList];
    const [dragged] = updated.splice(dragIndex, 1);
    updated.splice(hoverIndex, 0, dragged);

    setTabList(updated);
    handleTabState(updated);
  };

  const handleTabClick = value => {
    setLoading(true);
    onTabClick(value);
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <TabView
        key={tabList.length}
        activeIndex={tabList.findIndex(item => item.value == tabsValue)}
        onTabChange={tab => {
          if (tabList[tab?.index]?.value) {
            handleTabClick(tabList[tab?.index]?.value);
          }
        }}
        scrollable
        className="pf-tab-view tabview-reverse"
        pt={{
          nextButton: {
            className: 'shadow-none  w-2rem z-2 border-round-lg',
          },
          prevButton: {
            className: 'shadow-none w-2rem z-2 border-round-lg',
          },
          prevIcon: { className: 'primary-text' },
          nextIcon: { className: 'primary-text' },
        }}
      >
        {tabList.map((tab, index) => (
          <TabPanel
            key={tab.value}
            pt={{
              header: {
                className: 'px-3',
              },
              headerAction: {
                className: 'p-2 cursor-pointer px-2',
                onClick: e => {
                  e.stopPropagation();
                },
              },
            }}
            header={
              <DraggableHeader index={index} moveTab={moveTab}>
                <div className="flex gap-2 align-items-center cursor-pointer">
                  <i
                    className={`${tab.randomIcon}`}
                    style={{ color: tab.randomColor }}
                  />
                  <span className="text-sm">{tab.name}</span>
                </div>
              </DraggableHeader>
            }
          ></TabPanel>
        ))}

        {showAdd && (
          <TabPanel
            header={
              <div
                className="flex align-items-center gap-2 cursor-pointer text-primary"
                onClick={handleAddIcon}
              >
                <i className="pi pi-plus-circle" />
                &nbsp;Add
              </div>
            }
            pt={{
              headerAction: {
                className: 'py-2 px-3 cursor-pointer',
                onClick: e => {
                  e.stopPropagation();
                  handleAddIcon();
                },
              },
            }}
          />
        )}
      </TabView>
    </DndProvider>
  );
};

export default DraggableTabs;
